import { Box, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Stack, Typography } from '@vapor/material'
import { PortalName /* ReservationStateFragment, ReservedResourcePhase */ } from 'src/api/api.generated'
import { HicChip } from '../hic-chip/hic-chip'
import { IconDefinition, faArrowLeft, faArrowUpRightFromSquare, faBoxArchive, faEllipsisVertical, faHashtag, faInbox } from '@fortawesome/pro-regular-svg-icons'
import { faUserGroup, faPlaneArrival, faPlaneDeparture, faDoorClosed } from '@fortawesome/pro-light-svg-icons'
import { PortalAvatar } from 'src/app/pages/settings/channel/components/portal-avatar'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import { HiCIcon } from '../icons/icon'
import { borderColorChat, paddingChat } from './common'
import { HicIconButton } from '../hic-vapor/button/icon-button'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import { useState } from 'react'
// import { State } from 'src/app/pages/booking/reservation-detail/header/state'

export default function ChatHeader({
  portalName,
  guestName,
  reservationCode,
  checkin,
  checkout,
  guests,
  resources,
  /* reservationState,
  reservationId,
  optionExpiration,
  reservedResources, */
  onToBeRead,
  onArchive,
  onInbox,
  onReservation,
  onBack,
}: {
  portalName: PortalName
  guestName: string
  reservationCode: string
  checkin: Date | undefined
  checkout: Date | undefined
  guests: number
  resources: number
  /* reservationState: ReservationStateFragment
  reservationId: string
  optionExpiration: Date | null
  reservedResources: { phase: ReservedResourcePhase }[] | null */
  onToBeRead?: () => void
  onArchive?: () => void
  onInbox?: () => void
  onReservation?: () => void
  onBack?: () => void
}) {
  const { t } = useTranslation()
  const formatDate = useFormatDate()
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLButtonElement | null>(null)
  const popoverOpen = Boolean(popoverAnchor)

  return (
    <Stack gap={1} padding={paddingChat} borderBottom={1} borderColor={borderColorChat}>
      <Stack direction="row" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={1}>
          {onBack && (
            <HicIconButton onClick={onBack} size="small" sx={{ minWidth: '0!important', minHeight: '0!important', padding: '0' }}>
              <FontAwesomeIcon icon={faArrowLeft} size="2xl" />
            </HicIconButton>
          )}
          <PortalAvatar portal={portalName} sx={{ padding: '0', margin: '0' }} />
          <Typography variant="titleSmall">{guestName}</Typography>
          <HicChip text={reservationCode} icon={faHashtag} outlined />
          {/*
          FOR FUTURE USE
          <State
            readOnly={true}
            optionExpiration={optionExpiration ?? null}
            reservedResources={reservedResources ?? null}
            reservationState={reservationState}
            reservationId={reservationId}
          /> */}
        </Box>
        <HicIconButton
          sx={{ minWidth: '0!important' }}
          onClick={(event) => {
            setPopoverAnchor(event.currentTarget)
          }}
        >
          <FontAwesomeIcon icon={faEllipsisVertical} size="xl" />
        </HicIconButton>
        <Menu
          open={popoverOpen}
          anchorEl={popoverAnchor}
          onClose={() => {
            setPopoverAnchor(null)
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuList>
            {onToBeRead && <StyledMenuItem icon={faCircle} onClick={onToBeRead} text={t('pms.messages.to_be_read')} />}
            {onArchive && <StyledMenuItem icon={faBoxArchive} onClick={onArchive} text={t('pms.messages.archive')} />}
            {onInbox && <StyledMenuItem icon={faInbox} onClick={onInbox} text={t('pms.messages.in_arrive')} />}
            {onReservation && <StyledMenuItem icon={faArrowUpRightFromSquare} onClick={onReservation} text={t('pms.messages.see_reservation')} />}
          </MenuList>
        </Menu>
      </Stack>
      <Stack direction="row" gap={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <HiCIcon>
            <FontAwesomeIcon icon={faPlaneArrival} />
          </HiCIcon>
          <Typography variant="caption">{checkin ? formatDate(checkin, 'iii, PPP') : ''}</Typography>
          <HiCIcon>
            <FontAwesomeIcon icon={faPlaneDeparture} />
          </HiCIcon>
          <Typography variant="caption">{checkout ? formatDate(checkout, 'iii, PPP') : ''}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <HiCIcon>
            <FontAwesomeIcon icon={faUserGroup} />
          </HiCIcon>
          <Typography variant="caption">{guests}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <HiCIcon>
            <FontAwesomeIcon icon={faDoorClosed} />
          </HiCIcon>
          <Typography variant="caption">{resources}</Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}

const StyledMenuItem = (props: { onClick: React.MouseEventHandler<HTMLLIElement>; icon: IconDefinition; text: string; disabled?: boolean }) => {
  return (
    <MenuItem onClick={props.onClick} disabled={props.disabled}>
      <ListItemIcon>
        <HiCIcon>
          <FontAwesomeIcon icon={props.icon} size="sm" style={{ width: 20 }} />
        </HiCIcon>
      </ListItemIcon>
      <ListItemText>{props.text}</ListItemText>
    </MenuItem>
  )
}
